<template>
    <v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" max-width="520">
        <v-card>
            <v-card-title class="text-h6">
                Inscription en liste d'attente
            </v-card-title>
            <v-card-text>
                <div v-if="registerResult">
                    Votre inscription a été prise en compte.
                    <br />
                    Position actuelle: <strong>{{ registerResult.position }}</strong>
                </div>
            </v-card-text>
            <v-card-actions class="justify-end">
                <v-btn color="primary" @click="$emit('update:modelValue', false)">OK</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'RegisterListeAttenteDialog',
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
        registerResult: {
            type: Object,
            default: null,
        },
    },
    emits: ['update:modelValue'],
}
</script>
